import React from 'react';
import { Box } from '@mui/system';
import { FormIds } from '../../services';

const Forms = () => {
  return (
    <Box component={'span'}>
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          padding: '1rem',
          lineHeight: '2rem',
        }}
      >
        <ul>
          {/* <li>
            <a href={`/forms/${FormIds.budgetForm2026}`}>
              Budget Request Form (2026)
            </a>
          </li> */}
          {/* <li>
            <a href={`/forms/${FormIds.breastCancerSeminar2024}`}>
              Breast Cancer Registration Form (2024)
            </a>
          </li> */}

          {/* <li>
            <a href={`/forms/${FormIds.skateworldSpringBreak}`}>
              Skate World Skate Night Permission Form
            </a>
          </li> */}
          {/* <li>
            <a href={`/forms/${FormIds.breastCancerSeminar}`}>
              Breast Cancer Registration Form ({new Date().getFullYear()})
            </a>
          </li> */}
          <li>
            <a href={`/forms/${FormIds.budgetForm}`}>
              Budget Request Form (2027)
            </a>
          </li>
          {/* <li>
            <a href={`/budget-planning-letter-2024`}>
              2024 Budget Planning Letter
            </a>
          </li> */}
          {/* <li>
            <a href={`/forms/${FormIds.volunteer}`}>
              NMZ Employee and Volunteer Application Procedure
            </a>
          </li> */}
          <li>
            <a
              href={`https://forms.gle/Ta5d5WEjFt9zYm2q6`}
              target="_blank"
              rel="noreferrer"
            >
              New Mt. Zion Business Directory Form
            </a>
          </li>
          <li>
            <a href={`/background-checks`}>Background Check</a>
          </li>
          <li>
            <a href={`/forms/${FormIds.volunteer}`}>
              NMZ Employee and Volunteer Application Procedure
            </a>
          </li>
          <li>
            <a href={`/forms/${FormIds.requisitionForm}`}>
              Check and Requisition Form
            </a>
          </li>
          {/* <li>
            <a href={`/forms/${FormIds.bolden2024}`}>
              D. M. Bolden Scholarship Award Application
            </a>
          </li> */}
          {/* <li>
            <a href={`/forms/${FormIds.schoolBash2024}`}>
              Back to School Bash 2024
            </a>
          </li> */}
          {/* <li>
            <a href={`/forms/${FormIds.youthChristmasPart2024}`}>
              Youth Chrismas Party 2024
            </a>
          </li> */}
        </ul>
      </Box>{' '}
    </Box>
  );
};

export default Forms;
